import { readStored, writeStored } from '@/utils/storage.ts';

const STORAGE_KEY = 'lastWorkspaceId';

// Opening the app without a workspace in the URL continues in the one used last, or in the first one when nothing
// is stored.
export const readLastWorkspaceId = () => readStored(STORAGE_KEY);

export const writeLastWorkspaceId = (workspaceId: string) => writeStored(STORAGE_KEY, workspaceId);
